import { lazy } from "react";
import type { RouteConfig } from "@/types/routestypes";
import TeamActivityLeadPage from "@/pages/Dashboard/Dashboard360/TeamActivityLeadPage";

// Lazy-loaded components
const Dashboard = lazy(() => import("@/pages/Dashboard/Dashboard"));
const Dashboard360 = lazy(
  () => import("@/pages/Dashboard/Dashboard360/Dashboard360"),
);
const CallDetailedView = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/CallDetailedView"),
);
const DealsAndPipelinesView = lazy(
  () =>
    import("@/pages/Dashboard/Dashboard360/Details-View/DealsAndPipelinesView"),
);
const DealsLostReasonView = lazy(
  () =>
    import("@/pages/Dashboard/Dashboard360/Details-View/DealsLostReasonView"),
);
const UserPunchedView = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/VisitPunchedView"),
);
const VisitsView = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/VisitsViewPage"),
);
const JointVisits = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/JointVisits"),
);
const ListViewTopCall = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/ListViewTopCall"),
);
const UserIdleDetails = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/UserIdleDetails"),
);
const LeaveDetails = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/LeaveDetails"),
);
const VisitForm = lazy(
  () => import("@/pages/Dashboard/Dashboard/Detail-View/VisitForm"),
);

const AllWishes = lazy(
  () => import("@/pages/Dashboard/Dashboard/Card/AllWishes"),
);

const dashboard360Permissions = [
  "Top5Absentees",
  "Top5HalfDays",
  "Top5ExtraDays",
  "Top5PlannedLeaves",
  "Top5ClaimUpdate",
  "EmployeeLocation",
  "Top5Expense",
  "Customer",
  "Top5CustomerOrder",
  "DealsAndPipeline",
  "LeadsConversion",
  "OpportunityConversion",
  "OpportunityAgainstLeadSource",
  "LeadsOnAccountStageAgainstLeadSource",
  "Expense",
  "FeedLrm",
  "TaskOverview",
  "TeamWiseTask",
  "ListView",
  "SalesOverView",
  "LeadSource",
  "LeadStatus",
  "LeadStage",
  "Meetings",
  "Calls",
  "LostReason",
  "TagsByOpportunity",
  "TagsByWonOpportunity",
  "TagsByLostOpportunity",
  "ProductOrderStatus",
];

// ---------------- Dashboard Routes ----------------
const DashboardRoutes: RouteConfig = {
  path: "",
  pageName: "Dashboard",
  sidebar: { show: true, icon: "/assets/media/dashboardLogo.svg" },
  children: {
    DASHBOARD: {
      path: "dashboard",
      element: <Dashboard />,
      pageName: "Dashboard",
      sidebar: { show: true },
      children: {
        VISIT_PUNCHED_VIEW: {
          path: "userpunchedview",
          element: <UserPunchedView />,
          pageName: "User View",
          sidebar: { show: false },
        },
        VISITS: {
          path: "visits",
          element: <VisitsView />,
          pageName: "Visits View",
          sidebar: { show: false },
        },
        JOINT_VISITS: {
          path: "joint-visits",
          element: <JointVisits />,
          pageName: "Joint Visits View",
          sidebar: { show: false },
        },
        CALLS_VIEW: {
          path: "callsdetails",
          element: <ListViewTopCall />,
          pageName: "Call By Details",
          sidebar: { show: false },
          children: {
            CALL_DETAIL_VIEW: {
              path: "view/:userId",
              element: <CallDetailedView />,
              pageName: "Call By Details",
              sidebar: { show: false },
            },
          },
        },
        IDLE: {
          path: "useridle",
          element: <UserIdleDetails />,
          pageName: "User Idle",
          sidebar: { show: false },
        },
        LEAVE: {
          path: "leavedetails",
          element: <LeaveDetails />,
          pageName: "Leave Details",
          sidebar: { show: false },
        },
        DYNAMIC_FORM: {
          path: "visitform",
          element: <VisitForm />,
          pageName: "Dynamic Form Details",
          sidebar: { show: false },
        },
        ALL_WISHES: {
          path: "all-wishes",
          element: <AllWishes />,
          pageName: "Today's Celebrations",
          sidebar: { show: false },
        },
      },
    },
    DASHBOARD_360: {
      path: "dashboard360",
      element: <Dashboard360 />,
      pageName: "Dashboard 360",
      sidebar: { show: true, icon: "" },
      permission: dashboard360Permissions,
      children: {
        DEALSPIPELINES_VIEW: {
          path: "dealView",
          element: <DealsAndPipelinesView />,
          sidebar: { show: false },
        },
        DEALSLOST_REASON_VIEW: {
          path: "lostReasonView",
          element: <DealsLostReasonView />,
          sidebar: { show: false },
        },
      },
    },
    TEAM_ACTIVITY_LEAD: {
      path: "customer/timeline/:leadId",
      element: <TeamActivityLeadPage />,
      sidebar: { show: false },
    },
  },
};

export default DashboardRoutes;
